import { LockKey } from '@phosphor-icons/react'
import { useState } from 'react'
import { request } from '../api/client'
import { readSession, writeSession } from '../api/session'
import { useAuth } from '../auth/AuthContext'
import { Modal } from './Overlay'

export function ForcePasswordModal() {
  const { session, reloadContext } = useAuth()
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [error, setError] = useState('')
  const submit = async () => {
    if (newPassword.length < 8) return setError('新密码至少 8 位')
    try {
      await request({ url: '/system/user/profile/update-password', method: 'PUT', data: { oldPassword, newPassword } })
      const active = readSession()
      if (active) writeSession({ ...active, passwordChangeRequired: false })
      await reloadContext()
      window.location.reload()
    } catch (reason) { setError(reason instanceof Error ? reason.message : '修改失败') }
  }
  return <Modal title="首次登录，请修改密码" open={Boolean(session?.passwordChangeRequired)} onClose={() => {}} actions={<button className="primary-button" onClick={submit}><LockKey />确认修改</button>}>
    <p className="modal-lead">为了保护商户数据，修改初始密码后才能继续经营操作。</p>
    <label>当前密码<input type="password" value={oldPassword} onChange={(event) => setOldPassword(event.target.value)} /></label>
    <label>新密码<input type="password" value={newPassword} onChange={(event) => setNewPassword(event.target.value)} /></label>
    {error && <div className="form-error">{error}</div>}
  </Modal>
}
